import { createAction, props } from '@ngrx/store';
import { Substitute } from '../../shared/models/substitute.model';
import type { SubstituteScope } from './substitute.reducer';

export const SUBSTITUTE_ACTION_LOAD = '[Substitute] Load Substitutes';
export const SUBSTITUTE_ACTION_RELOAD = '[Substitute] Reload Substitutes';
export const SUBSTITUTE_ACTION_SUCCESS = '[Substitute] Load Substitutes Success';
export const SUBSTITUTE_ACTION_FAILURE = '[Substitute] Load Substitutes Failure';
export const SUBSTITUTE_ACTION_DELETE = '[Substitute] Delete Substitute';

export const loadSubstitutes = createAction(
  SUBSTITUTE_ACTION_LOAD,
  props<{ scope: SubstituteScope }>(),
);
export const reloadSubstitutes = createAction(
  SUBSTITUTE_ACTION_RELOAD
);
export const loadSubstitutesSuccess = createAction(
  SUBSTITUTE_ACTION_SUCCESS,
  props<{ data: Substitute[] }>(),
);
export const loadSubstitutesFailure = createAction(
  SUBSTITUTE_ACTION_FAILURE,
  props<{ error: Error }>(),
);
export const deleteSubstitute = createAction(
  SUBSTITUTE_ACTION_DELETE,
  props<{ userName?: string; substituteUserName: string; scope: SubstituteScope }>(),
);




